module.exports = __webpack_public_path__ + "static/media/jazz_img.e5e2e03e.png";